import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloHourGlassIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.4232 7.19498L10.8158 10L14.4232 12.805C14.7887 13.0892 15.0024 13.5262 15.0024 13.9892V16C15.0024 16.8284 14.3309 17.5 13.5024 17.5H6.5C5.67157 17.5 5 16.8284 5 16V13.9892C5 13.5262 5.21377 13.0892 5.57924 12.805L9.18667 10L5.57924 7.19498C5.21377 6.91081 5 6.47379 5 6.01084V4C5 3.17157 5.67157 2.5 6.5 2.5H13.5024C14.3309 2.5 15.0024 3.17157 15.0024 4V6.01083C15.0024 6.47379 14.7887 6.91081 14.4232 7.19498ZM6 4C6 3.72386 6.22386 3.5 6.5 3.5H13.5024C13.7786 3.5 14.0024 3.72386 14.0024 4V4.5H6V4ZM6 5.5V6.01084C6 6.16515 6.07126 6.31083 6.19308 6.40555L10.0012 9.36663L13.8094 6.40555C13.9312 6.31083 14.0024 6.16515 14.0024 6.01083V5.5H6ZM6.19308 13.5944L10.0012 10.6334L13.8094 13.5944C13.9312 13.6892 14.0024 13.8348 14.0024 13.9892V16C14.0024 16.2761 13.7786 16.5 13.5024 16.5H6.5C6.22386 16.5 6 16.2761 6 16V13.9892C6 13.8348 6.07126 13.6892 6.19308 13.5944Z'
      fill='currentColor'
    />
  </EloBaseIcon>
)
